import { useEffect, useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import CustomCursor from "@/components/CustomCursor";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const id = setInterval(() => {
      const lenis = lenisRef.current?.lenis;
      if (lenis) {
        window.__lenis = lenis;
        clearInterval(id);
      }
    }, 100);
    return () => clearInterval(id);
  }, []);

  return (
    <ReactLenis root ref={lenisRef} options={{ lerp: 0.09, smoothWheel: true }}>
      <div className="App">
        <CustomCursor />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" richColors />
      </div>
    </ReactLenis>
  );
}

export default App;
